import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import ButtonComponent from './forms/Button/ButtonComponent';

export default class ErrorsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { dataState: { errors: {}, isVisible: false } };
  }

  setErrors(errors) {
    this.setState({
      dataState: {
        errors,
        isVisible: true,
      },
    });
  }

  setVisibility(isVisible) {
    this.setState((prevState) => ({
      dataState: {
        ...prevState.dataState,
        isVisible,
      },
    }));
  }

  render() {
    const { dataState } = this.state;
    return <Errors dataState={dataState} onClose={() => this.setVisibility(false)} />;
  }
}

function Errors({ dataState, onClose }) {
  useEffect(() => {
    let timeOut;
    if (dataState.isVisible) {
      timeOut = setTimeout(() => {
        onClose();
      }, 6000);
    }
    return () => clearTimeout(timeOut);
  }, [dataState.isVisible]);

  return (
    <>
      {dataState.isVisible && dataState.errors.length > 0 && (
        <StyledErrorContainer>
          <ButtonComponent onClick={onClose} title="&times;" />
          <StyledError>
            <span className="error__text">
              {dataState.errors.length > 0 &&
                dataState.errors.map((error) => (
                  <div key={uuid()}>{error.key ? `${error.key}: ${error.data}` : error.data}</div>
                ))}
            </span>
          </StyledError>
        </StyledErrorContainer>
      )}
    </>
  );
}

Errors.propTypes = {
  dataState: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

const StyledErrorContainer = styled.div`
  background-color: #303030;
  position: fixed;
  left: 20px;
  bottom: 40px;
  padding: 22px 30px;
  border-radius: 5px;
  color: #fff;
`;

const StyledError = styled.div`
  &__close {
    position: absolute;
    right: 6px;
    top: 6px;
    float: right;
    font-size: 1.4em;
    line-height: 22px;
  }
`;
